import { FC, SVGProps } from 'react';

const SearchIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6781 12.9272C17.1884 9.50167 16.637 4.72072 13.4128 1.95655C10.1886 -0.807627 5.37957 -0.622325 2.37764 2.38175C-0.624288 5.38583 -0.806149 10.195 1.96033 13.4172C4.72681 16.6395 9.50816 17.1874 12.9319 14.6746H12.9306C12.9681 14.7246 13.0081 14.7721 13.0531 14.8184L17.8655 19.6307C18.3535 20.1191 19.1451 20.1194 19.6335 19.6313C20.1219 19.1433 20.1222 18.3517 19.6341 17.8633L14.8218 13.051C14.7771 13.0057 14.7291 12.9639 14.6781 12.926V12.9272ZM15.0006 8.1224C15.0006 10.5785 13.6903 12.848 11.5632 14.0761C9.43615 15.3041 6.81552 15.3041 4.68847 14.0761C2.56142 12.848 1.2511 10.5785 1.2511 8.1224C1.2511 4.32558 4.32902 1.24766 8.12583 1.24766C11.9226 1.24766 15.0006 4.32558 15.0006 8.1224Z"
      fill="#4B4F54"
    />
  </svg>
);

export default SearchIcon;
